'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiTimesOutline = function TiTimesOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.7 31.7c-1.4 0-2.6-0.6-3.6-1.5l-3.1-3.1-3.1 3.1c-1.9 1.9-5.2 1.9-7.1 0-0.9-0.9-1.5-2.2-1.5-3.5s0.6-2.6 1.5-3.6l3.1-3.1-3.1-3.1c-0.9-1-1.5-2.2-1.5-3.6s0.6-2.6 1.5-3.5c1.9-1.9 5.2-1.9 7.1 0l3.1 3.1 3.1-3.1c1.9-1.9 5.2-1.9 7.1 0 0.9 0.9 1.5 2.2 1.5 3.5s-0.6 2.6-1.5 3.6l-3.1 3.1 3.1 3.1c0.9 1 1.5 2.2 1.5 3.6s-0.6 2.6-1.5 3.5c-0.9 0.9-2.2 1.5-3.5 1.5z m-6.7-9.3l5.5 5.4c0.6 0.7 1.7 0.7 2.3 0 0.4-0.3 0.5-0.7 0.5-1.1s-0.1-0.9-0.5-1.2l-5.4-5.5 5.4-5.5c0.4-0.3 0.5-0.7 0.5-1.2s-0.1-0.8-0.5-1.1c-0.6-0.7-1.7-0.7-2.3 0l-5.5 5.4-5.5-5.4c-0.6-0.7-1.7-0.7-2.3 0-0.4 0.3-0.5 0.7-0.5 1.1s0.1 0.9 0.5 1.2l5.4 5.5-5.4 5.5c-0.4 0.3-0.5 0.7-0.5 1.2s0.1 0.8 0.5 1.1c0.6 0.7 1.7 0.7 2.3 0l5.5-5.4z' })
        )
    );
};

exports.default = TiTimesOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/times-outline.js
// module id = 3773
// module chunks = 0